module.exports = __webpack_public_path__ + "fromGroomToMother-we-n.ba64e46a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromGroomToMother-we-n.jpg
// module id = kt0f
// module chunks = 0